export const logClick = (eventMonitor = '', event = {}) => {
  try {
    let id = event.target.id
    let klass = event.target.className
    let payload = {
      event,
      target: event.target,
      class: klass,
      id: id
    }

    // Emit event by ID
    id && eventMonitor.emit(`click:id:${id}`, payload)

    // Emit event by class
    klass && eventMonitor.emit(`click:class:${klass}`, payload)

    // Emit generic click events
    eventMonitor.emit('click', payload)
  } catch (error) {
    MK.captureException && MK.captureException(error)
  }
}


